import { API_BASE_URL } from "src/config/apiBase";
import React, { useState, useEffect } from 'react';
import '../CSS/Global.css';
import { useSidebar } from '../SidebarContext';
import Header from './Header';
import Sidebar from './SideBar';
import userImg from "../Img/User img2.png"
import UserRegisterModal from './UserRegisterModal';
import { toast } from 'react-toastify';
import UserRegisterEditModal from './UserRegisterEditModal';
import { getDecryptedUserFromCookie } from './utils/getCookie';
import Swal from 'sweetalert2';
import axios from 'axios';
import { decryptToken } from './utils/getToken';

const UserRecordSuper = () => {


    // State Variables
    const [searchQuery, setSearchQuery] = useState('');

    const [data, setData] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isModalOpenEdit, setIsModalOpenEdit] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [dataEdit, setDataEdit] = useState({
        id: "",
        full_name: "",
        email: ""
    })
    const urlmain = API_BASE_URL
    const itemsPerPage = 10;
    const login = decryptToken("accessToken") || ""
    const [categories, setCategories] = useState([])
    const userData = getDecryptedUserFromCookie("gta_mainstateuser");
    const token = decryptToken("accessToken") || ""

    const fetchData = async () => {
        try {
            const response = await fetch(`${urlmain}/register/admin1997`, {
                method: 'GET',
                credentials: "include",
                headers: {
                    "Authorization": `Bearer ${login}`,
                }
            })
            const res = await response.json();
            setData((res.users).reverse());
        } catch (error) {
            toast.error(error)
        }
    }

    const [filteredCustomers, setFilteredCustomers] = useState(data);

    // Effect to handle filtering
    useEffect(() => {
        const filtered = data.filter((customer) =>
            Object.values(customer).some((value) =>
                String(value).toLowerCase().includes(searchQuery.toLowerCase())
            )
        );
        setFilteredCustomers(filtered);
        setCurrentPage(1); // Reset to first page on new search
    }, [searchQuery, data]);


    const toggleActive = async (index, userId) => {
        try {
            const response = await fetch(`${urlmain}/register/toggle-status/${userId}`, {
                method: 'PATCH',
                credentials: "include",
                headers: {
                    "Authorization": `Bearer ${login}`,
                }
            });
            const result = await response.json();
            if (!result.isError) {
                const updated = [...data];
                updated[index].status = result.status;
                toast.success(result.message)
                setData(updated);
            } else {
                toast.error(result.message)
            }
        } catch (error) {
            toast.error(error)
        }
    };

    // Pagination Logic
    const totalPages = Math.ceil(filteredCustomers.length / itemsPerPage);
    const currentData = filteredCustomers.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
    );

    // const toggleActive = (index) => {
    //     const updatedPlans = [...data];
    //     updatedPlans[index].active = !updatedPlans[index].active;
    //     setData(updatedPlans);
    // };

    const fetchCategories = async () => {
        try {
            const response = await fetch(`${urlmain}/category-main/getdata/category/${userData.main_id}`, {
                method: "GET",
                // credentials: "include"
            })
            const res = await response.json();
            setCategories(res);
        } catch (error) {
            console.error(error)
        }
    }

    const handleDelete = async (mainId) => {
        Swal.fire({
            title: 'Are you sure?',
            text: 'This will be permanently deleted',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Yes, delete it!'
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const response = await fetch(`${urlmain}/register/${mainId}`, {
                        method: 'DELETE',
                        headers: {
                            Authorization: `Bearer ${token}`,
                        }
                    });
                    if (!response.ok) {
                        const err = await response.json();
                        throw new Error(err?.message || 'Failed to delete');
                    }

                    Swal.fire('Deleted!', 'User has been deleted.', 'success');
                    setData((prev) => prev.filter((item) => item.id !== mainId));
                } catch (error) {
                    console.error('Delete error:', error.message);
                    Swal.fire('Error!', `Failed to delete user. ${error.message}`, 'error');
                }
            }
        })
    }

    useEffect(() => {
        fetchData();
        fetchCategories();
    }, [])

    const handleSearch = (e) => setSearchQuery(e.target.value);
    const paginate = (pageNumber) => setCurrentPage(pageNumber);
    return (
        <>
            <div className="oms-header">
                <h1 className="dashboard-title">User records</h1>

                <button className="oms-add-btn"
                    onClick={() => setIsModalOpen(true)}
                >
                    Add User
                </button>
            </div>

            {/* Search Filter */}
            <div className="filter-search">
                <div className="filter-search-input">
                    <input
                        type="search"
                        placeholder="Search..."
                        value={searchQuery}
                        onChange={handleSearch}
                    />
                    <i className="fa fa-search"></i> {/* Font Awesome Search Icon */}
                </div>
            </div>

            {/* Customer Table */}
            <div className="customer-table">
                <table>
                    <thead>
                        <tr>
                            <th>Photo</th>
                            <th>User ID</th>
                            <th>Name</th>
                            <th>Email</th>
                            <th>Category</th>
                            <th>Status</th>
                            <th>Type</th>
                            <th>Actions</th>
                            {/* <th>Age</th>
                                <th>Date</th> */}
                        </tr>
                    </thead>
                    <tbody>
                        {currentData.length > 0 ? (
                            currentData.map((customer, index) => (
                                <tr key={index}>
                                    <td>
                                        <img
                                            src={userImg}
                                            alt={customer.full_name}
                                            style={{ width: '50px', height: '50px', borderRadius: '50%' }}
                                        />
                                    </td>
                                    <td>{customer.main_id}</td>
                                    <td>{customer.full_name}</td>
                                    <td>{customer.email}</td>
                                    <td>{customer.category}</td>
                                    <td>
                                        <button
                                            onClick={() => toggleActive(index, customer.id)}
                                            className="toggle-btn"
                                        >
                                            <i className={`fa ${customer.status === "Active" ? 'fa-toggle-on' : 'fa-toggle-off'}`}></i>
                                        </button>
                                    </td>
                                    <td>{customer.type}</td>
                                    <td>
                                        {/* <button onClick={() => {
                                                setIsModalOpenEdit(true)
                                                setDataEdit({
                                                    id: customer.id,
                                                    full_name: customer.full_name,
                                                    email: customer.email,
                                                    category: customer.category
                                                })
                                            }}>
                                                <i className="fa-solid fa-pencil"></i>
                                            </button> */}
                                        <div className="action-buttons">
                                            <button onClick={() => {
                                                setIsModalOpenEdit(true)
                                                setDataEdit({
                                                    id: customer.id,
                                                    full_name: customer.full_name,
                                                    email: customer.email,
                                                    category: customer.category
                                                })
                                            }}>
                                                <i className="fa-solid fa-pencil"></i>
                                            </button>
                                            <button
                                                onClick={() => handleDelete(customer.id)}
                                                className="delete-btn"
                                            // style={{ marginLeft: '8px' }}
                                            >
                                                <i className="fa-solid fa-trash"></i>
                                            </button>
                                        </div>
                                    </td>
                                    {/* <td>{customer.age}</td>
                                        <td>{customer.date}</td> */}
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="8" style={{ textAlign: 'center' }}>No customers found.</td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>

            {/* Pagination */}
            <div className="pagination">
                <button
                    onClick={() => paginate(currentPage - 1)}
                    disabled={currentPage === 1}
                >
                    Previous
                </button>
                {Array.from({ length: totalPages }, (_, index) => (
                    <button
                        key={index}
                        onClick={() => paginate(index + 1)}
                        className={currentPage === index + 1 ? 'active' : ''}
                    >
                        {index + 1}
                    </button>
                ))}
                <button
                    onClick={() => paginate(currentPage + 1)}
                    disabled={currentPage === totalPages}
                >
                    Next
                </button>
            </div>
            <UserRegisterModal isOpen={isModalOpen} setIsOpen={setIsModalOpen} fetchData={fetchData} categories={categories} />
            <UserRegisterEditModal isOpen={isModalOpenEdit} setIsOpen={setIsModalOpenEdit} fetchData={fetchData} dataEdit={dataEdit} categories={categories} />

        </>
    );
};

export default UserRecordSuper;
